import React from 'react';
import { formatRelativeTime } from '../../utils/formatters';
import {
  ShoppingBag,
  Package,
  UserPlus,
  RefreshCw,
  Receipt,
  LogIn,
  Activity
} from 'lucide-react';

const iconMap = {
  sale_created: ShoppingBag,
  product_added: Package,
  customer_registered: UserPlus,
  stock_updated: RefreshCw,
  expense_recorded: Receipt,
  user_login: LogIn,
  default: Activity
};

const ActivityFeed = ({ activities = [], loading = false }) => {
  if (loading) {
    return (
      <div className="bg-theme-secondary rounded-lg shadow-theme-md p-4 md:p-6 border border-theme">
        <div className="h-5 w-32 bg-theme-tertiary rounded mb-4 animate-pulse"></div>
        <div className="space-y-3">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="flex items-start space-x-3 animate-pulse">
              <div className="w-8 h-8 bg-theme-tertiary rounded-full"></div>
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-theme-tertiary rounded w-3/4"></div>
                <div className="h-3 bg-theme-tertiary rounded w-1/4"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!activities || activities.length === 0) {
    return (
      <div className="bg-theme-secondary rounded-lg shadow-theme-md p-4 md:p-6 border border-theme">
        <h3 className="text-base md:text-lg font-semibold text-theme-primary mb-4">Recent Activity</h3>
        <div className="flex flex-col items-center justify-center py-8 text-theme-muted">
          <Activity className="w-12 h-12 mb-2 opacity-30" />
          <p className="text-sm">No recent activity to display</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-theme-secondary rounded-lg shadow-theme-md p-4 md:p-6 border border-theme">
      <h3 className="text-base md:text-lg font-semibold text-theme-primary mb-4">Recent Activity</h3>
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {activities.map((activity) => {
          const IconComponent = iconMap[activity.action_type] || iconMap.default;

          return (
            <div
              key={activity.id}
              className="flex items-start space-x-3 p-3 rounded-lg hover:bg-theme-tertiary transition-colors"
            >
              <div className="flex-shrink-0">
                <div className="w-8 h-8 rounded-full bg-accent-gold bg-opacity-10 flex items-center justify-center">
                  <IconComponent className="w-4 h-4 text-accent-gold" />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-theme-primary">
                  <span className="font-medium">{activity.user_name || 'System'}</span>
                  {' '}
                  <span className="text-theme-secondary">{activity.description || activity.action_type}</span>
                </p>
                <p className="text-xs text-theme-muted mt-1">
                  {formatRelativeTime(activity.created_at)}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ActivityFeed;
